const workerInstance = () => {
  return function (event) {
    this.networkStatus = undefined;
    if (event.data.type === "onlineStatus") {
      this.networkStatus = event.data.onlineStatus;
      return;
    }
    console.log("[RTDWC]", "*** Keepalive Worker Thread ***");
    this.intervalId;
    this.intervalDuration;
    this.pingURL;
    this.timeOutId;
    this.initialized = false;
    this.isSocketClosed;
    this.initiateWebSocketClosure = false;
    this.closeSocketTimeout = 16000;

    const resetOfflineHandler = () => {
      if (this.timeOutId) {
        this.initialized = false;
        clearTimeout(this.timeOutId);
        this.timeOutId = null;
      }
    };

    // checking initialized here so as to reset only when timer is initialized
    // network comes back online but page hasn't recovered, thus can't clear timer here
    const checkOnlineStatus = async () => {
      const METHOD_NAME = this.pingURL && this.pingURL.includes("localhost") ? "GET" : "HEAD";
      if (this.pingURL) {
        try {
          const online = await fetch(this.pingURL, {
            //change here pingURL while checkin
            method: METHOD_NAME,
            headers: {
              "cache-control": "no-cache, no-store, must-revalidate"
            }
          });
          return online.status === 200;
          // eslint-disable-next-line sonarjs/no-ignored-exceptions
        } catch (error) {
          return false;
        }
      } else {
        return typeof this.networkStatus === "undefined" ? navigator.onLine : this.networkStatus;
      }
    };

    const checkNetworkStatus = async () => {
      const onlineStatus = await checkOnlineStatus();
      postMessage({
        type: "keepalive",
        onlineStatus
      });
      if (!onlineStatus && !this.initialized) {
        this.initialized = true;
        console.log("[RTDWC] worker socket closing initialized");
        // sets a timeout of 16s, checks if socket didn't close then it closes forcefully
        this.timeOutId = setTimeout(() => {
          if (!this.isSocketClosed && this.initialized) {
            this.initiateWebSocketClosure = true;
            postMessage({
              type: "closeSocket"
            });
            clearInterval(this.intervalId);
            this.intervalId = null;
            resetOfflineHandler();
          }
        }, this.closeSocketTimeout);
      }

      // checking initialized here so as to reset only when timer is initialized
      // network comes back online but page hasn't recovered, thus can't clear timer here
      if (onlineStatus && this.initialized) {
        console.log("[RTDWC] connection restored");
        this.initialized = false;
      }

      // once websocket closure is initiated, we can clear timer
      // if page recovers within this time frame, doesn't close the websocket
      if (this.initiateWebSocketClosure) {
        this.initiateWebSocketClosure = false;
        clearTimeout(this.timeOutId);
        this.timeOutId = null;
      }
    };

    if (event.data?.type === "start") {
      this.intervalDuration = event.data?.intervalDuration || 4000;
      this.pingURL = event.data?.pingURL;
      this.isSocketClosed = event.data?.isSocketClosed;
      this.closeSocketTimeout = event.data?.closeSocketTimeout || 16000;

      console.log("[RTDWC]", "event=Websocket startWorker | keepalive Worker started");
      this.intervalId = setInterval(
        (checkIfSocketClosed) => {
          checkNetworkStatus();
          this.isSocketClosed = checkIfSocketClosed;
        },
        this.intervalDuration,
        event.data?.isSocketClosed
      );
      resetOfflineHandler();
    }

    if (event.data?.type === "terminate" && this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
      resetOfflineHandler();
      console.log("[RTDWC]", "terminated and cleared interval");
    }
  };
};

const createWorker = (fn) => {
  const urlToBeRevoked = localStorage.getItem("workerUrl");
  URL.revokeObjectURL(urlToBeRevoked);
  const blob = new Blob(["self.onmessage = ", fn.toString()], { type: "text/javascript" });
  const url = URL.createObjectURL(blob);
  localStorage.setItem("workerUrl", url);
  return new Worker(url);
};

module.exports = { workerInstance, createWorker };
